(function (angular) {
  "use strict";

  angular.module("Toyota.Services").service("PageOptions", function () {
    var exports = this;
    var reloadOnDealerLocationChange = undefined;

    exports.getReloadOnDealerLocationChange = function () {
      return reloadOnDealerLocationChange;
    };

    exports.setReloadOnDealerLocationChange = function (flag) {
      reloadOnDealerLocationChange = flag;
    };

    return exports;
  });
})(window.angular);
